import React from "react";
import { Row, Col, Form } from "react-bootstrap";

const DynamicFormRenderer = ({
  schema,
  values = {},
  setValues,
  errors = {},
  setErrors,
}) => {
  const isReadOnly = typeof setValues !== "function";

  console.log("values =", values);
  console.log("setValues =", setValues);
  if (!schema?.fields?.length) return null;

 const handleChange = (field, value) => {
  if (isReadOnly) return;

  const max = Number(field.maxLength);

  // Skip maxLength validation for fields that don't have it
  if (!field.maxLength || value.length <= max) {
    setValues((prev) => ({
      ...prev,
      [field.id]: value,
    }));

    setErrors?.((prev) => ({
      ...prev,
      [field.id]: "",
    }));
  } else {
    setErrors?.((prev) => ({
      ...prev,
      [field.id]: `Maximum ${max} characters allowed`,
    }));
  }
};
  return (
    <div className="mt-4">
      <h5>{schema.title}</h5>

      <Row>
        {schema.fields.map((field) => (
          <Col md={6} className="mb-3" key={field.id}>
            <Form.Label>
              {field.label}
              {field.required && <span className="text-danger">*</span>}
            </Form.Label>

            {field.type === "text" && (
              <>
                <Form.Control
                  value={values[field.id] || ""}
                  placeholder={field.placeholder}
                  readOnly={isReadOnly}
                  isInvalid={!!errors?.[field.id]}
                  onChange={(e) => handleChange(field, e.target.value)}
                />

                {errors?.[field.id] && (
                  <div className="invalid-feedback d-block">
                    {errors[field.id]}
                  </div>
                )}
              </>
            )}

            {field.type === "dropdown" && (
              <>
                <Form.Select
                  value={values[field.id] || ""}
                  isInvalid={!!errors?.[field.id]}
                  disabled={isReadOnly}
                  onChange={(e) => handleChange(field, e.target.value)}
                >
                  <option value="">Select</option>

                  {field.options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Form.Select>

                {errors?.[field.id] && (
                  <div className="invalid-feedback d-block">
                    {errors[field.id]}
                  </div>
                )}
              </>
            )}

            {field.type === "date" && (
              <>
                <Form.Control
                  type="date"
                  value={values[field.id] || ""}
                  readOnly={isReadOnly}
                  isInvalid={!!errors?.[field.id]}
                  onChange={(e) => handleChange(field, e.target.value)}
                />

                {errors?.[field.id] && (
                  <div className="invalid-feedback d-block">
                    {errors[field.id]}
                  </div>
                )}
              </>
            )}
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DynamicFormRenderer;